import * as actionTypes from "../../constants/actionTypes";
import { getDataSpeedGenIds, getDataSpeedGens } from "../../api/dataSpeedGen";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidateDataSpeedGens = () => {
  return {
    type: actionTypes.INVALIDATE_DATA_SPEED_GENS_DATA
  };
};

const loadDataSpeedGenPropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_DATA_SPEED_GEN_PROPOSITION_IDS_DATA,
    promise: getDataSpeedGenIds(
      clientConfig,
      OFFER_TYPES.proposition,
      dataStatus
    )
  };
};

const loadDataSpeedGenSimOnlyIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_DATA_SPEED_GEN_SIM_ONLY_IDS_DATA,
    promise: getDataSpeedGenIds(clientConfig, OFFER_TYPES.simOnly, dataStatus)
  };
};

const loadDataSpeedGens = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_DATA_SPEED_GENS_DATA,
    promise: getDataSpeedGens(clientConfig, dataStatus)
  };
};

export {
  invalidateDataSpeedGens,
  loadDataSpeedGenPropositionIds,
  loadDataSpeedGenSimOnlyIds,
  loadDataSpeedGens
};
